export default __webpack_public_path__ + "static/media/no-tests.3f5e6060.png";